import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
    FormGroup,
    FormControlLabel,
    Switch,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { Save } from '@mui/icons-material';
import { format } from 'date-fns';
import { makeid, myTimestampToDate, propComparatorDate, propComparatorDateTime } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { add_user, set_user_claim, update_user } from '../FirebaseUtils/dbUser';
import { useAuth } from '../core/AuthProvider';
import { newuser, access_level_list } from '../definitions/user';
import { MyInput } from '../components/MyInput';
import { MyCloseBtn } from '../components/MyButtons';
import { NewIcon } from '../components/NewIcon';
import { get_Event_list } from '../FirebaseUtils/dbEvent';






export const UserDialog = forwardRef(({ element, reloadFn, t, ui_list, }, ref) => {
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newuser })
    const { user } = useAuth()
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)






    useImperativeHandle(ref, () => {
        return {
            onNew() {
                setCurElement({ ...newuser, user_code: makeid(8, true) })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
            },
            onEdit(el, i, is_c) {
                console.log("IS CURRENT", is_c)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newuser, ...el }
                setCurElement(_el)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setOpen(false);
    };


    const handleSave = async () => {
        console.log("USER", user, curElement)
        const cb_error = (c) => {
            console.log("ERROR DB", c)
        }
        let _el = { ...curElement }
        delete _el.password_check
        if (is_new) {
            const u_data = await add_user(user.uid, _el, cb_error)
            console.log(u_data)
            set_user_claim(u_data.uid, curElement.admin, curElement.access_level)
            reloadFn()
        } else {
            update_user(_el.uid, _el)
            reloadFn(_el)
        }
        setOpen(false)
    }



    const onChangeHandler = (el, level) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked

        }
        if (value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
            setIsEdited(true)
        }
    }


    const checkNotValid = () => {
        if (curElement.displayName.length === 0) {
            return true

        }
        if (curElement.email.length === 0) {
            return true
        }
        if (is_new && (!curElement.password || curElement.password.length < 5)) {
            return true
        }
        return false
    }






    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
                <DialogTitle>
                    <NewIcon is_new={is_new} />
                    Dati Utente:  {curElement.user_name}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <MyInput
                            id="displayName"
                            label={'Nome visualizzato'}
                            value={curElement.displayName}
                            onChange={(ev) => onChangeHandler(ev.target, -1)}
                        />
                        <MyInput
                            id="email"
                            label={'Email'}
                            value={curElement.email}
                            onChange={(ev) => onChangeHandler(ev.target, -1)}
                        />
                        <FormControl sx={{ mt: 1, minWidth: 320 }} size="small">
                            <InputLabel id="select_filter_label">Livello di accesso</InputLabel>
                            <Select
                                labelId="access_level-label"
                                id="accessLevel"
                                value={curElement.accessLevel}
                                size="small"
                                onChange={(ev) => onChangeHandler({ accessLevel: ev.target.value }, true)}
                            >
                                <MenuItem value="">
                                    <em>seleziona livello</em>
                                </MenuItem>
                                {access_level_list.map((g, gk) => (
                                    <MenuItem key={gk} value={g.id}>
                                        {g.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {curElement.accessLevel >2 &&
                        <EventSelectorSection curElement={curElement} onChangeHandler={onChangeHandler} />
                        }
                        <PasswordSection curElement={curElement} onChangeHandler={onChangeHandler} is_new={is_new} />
                        <FormGroup>
                            <FormControlLabel control={<Switch color="error" name="disabled" checked={curElement.disabled} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                            />} label={"disabilitato"} />
                        </FormGroup>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <MyCloseBtn handleClose={handleClose} />
                    {isEdited &&
                        <LoadingButton key={'bs'} disabled={checkNotValid()} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">salva</LoadingButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})




const PasswordSection = ({ curElement, onChangeHandler, is_new }) => {
    const [resetPassword, setResetPassword] = useState(false)
    const [passwordError, setPasswordError] = useState('')
    useEffect(() => {
        if (curElement.password && curElement.password.length > 5) {
            if (curElement.password_check) {
                if (curElement.password_check !== curElement.password) {
                    setPasswordError('le password non corrispondono')
                } else {
                    setPasswordError('')
                }
            } else {
                setPasswordError('')
            }
        } else {
            setPasswordError('la password dev\'essere lunga almeno sei caratteri.')
        }

    }, [curElement.password, curElement.password_check])
    return (
        (is_new || resetPassword) &&
        <>
            <MyInput
                id="password"
                label={'password'}
                value={curElement.password}
                onChange={(ev) => onChangeHandler(ev.target, -1)}
            />
            <MyInput
                id="password_check"
                label={'password (verifica)'}
                value={curElement.password_check}
                onChange={(ev) => onChangeHandler(ev.target, -1)}
            />
            <Typography sx={{ fontSize: '0.6em', color: 'red' }}>
                {passwordError}
            </Typography>
        </>

    )

}


const EventSelectorSection = ({curElement, onChangeHandler}) => {
    const [event_list, setEventlist ] = useState([])
    const initEventlist = async () => {
        const data =  await get_Event_list() 
        setEventlist(data.sort(propComparatorDateTime('event_start')))
    }

    useEffect(() => {
        initEventlist()
    }, [])
    return (
        <Box>
            {event_list.map((e,k) => (
                <Grid size={3} key={k}>
                    {e.event_name}
                {format(myTimestampToDate(e.event_start), 'dd/MM/yyyy')} -&nbsp;
                </Grid>
            ))}
        </Box>
    )


}